import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../_metronic/helpers'
import {VisaDashboardQueryResponce} from './_models'



const API_URL = process.env.REACT_APP_THEME_API_URL
const DASHBOARD_URL = `${API_URL}/visadashboard`

const getvisadashborddata = (query: string): Promise<VisaDashboardQueryResponce> => {
    return axios
      .get(`${DASHBOARD_URL}?${query}`)
      .then((d: AxiosResponse<VisaDashboardQueryResponce>) => {
        console.log("API Response:", d.data);
      return d.data
      })
      
  }
  
  export {getvisadashborddata}